import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=43accf8a&scoped=true&"
import script from "./MetricCard.vue?vue&type=script&lang=js&"
export * from "./MetricCard.vue?vue&type=script&lang=js&"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=43accf8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43accf8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43accf8a')) {
      api.createRecord('43accf8a', component.options)
    } else {
      api.reload('43accf8a', component.options)
    }
    module.hot.accept("./MetricCard.vue?vue&type=template&id=43accf8a&scoped=true&", function () {
      api.rerender('43accf8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/reports/components/overview/MetricCard.vue"
export default component.exports